import { memo } from 'react'

import type { ColumnDef } from '@tanstack/react-table'
import random from 'lodash/random'

import { DataTable } from '@/components/ui/table/data-table'

export const FunnelChecksTableSkeleton = memo(() => {
  const columns: ColumnDef<unknown>[] = [
    {
      header: 'Account',
      cell: () => {
        return (
          <div className="flex items-center gap-2.5">
            <span className="inline-block h-8 w-8 animate-pulse rounded-full  bg-skeleton" />

            <div className="flex flex-col gap-1">
              <span
                style={{ width: `${random(64, 120)}px` }}
                className="inline-block h-5 w-16 animate-pulse rounded-md bg-skeleton"
              />
              <span
                style={{ width: `${random(40, 70)}px` }}
                className="inline-block h-4 w-10 animate-pulse rounded-md bg-skeleton"
              />
            </div>
          </div>
        )
      },
    },
    {
      header: 'Entry Point',
      cell: () => {
        return (
          <span
            style={{ width: `${random(40, 120)}px` }}
            className="inline-block h-5 animate-pulse rounded-md bg-skeleton"
          />
        )
      },
    },
    {
      header: 'Last Checked',
      cell: () => {
        return (
          <span
            style={{ width: `${random(40, 120)}px` }}
            className="inline-block h-5 w-40 animate-pulse rounded-md bg-skeleton"
          />
        )
      },
    },
    {
      header: 'Status',
      cell: () => {
        return (
          <span className="inline-block  h-8 w-24 animate-pulse rounded-3xl bg-skeleton" />
        )
      },
    },
    {
      header: 'Fail info',
      cell: () => {
        return (
          <span
            style={{ width: `${random(40, 120)}px` }}
            className="inline-block  h-5 w-24 animate-pulse rounded-md bg-skeleton"
          />
        )
      },
    },
    {
      header: 'Action',
      cell: () => {
        return (
          <span className="inline-block h-5 w-20  animate-pulse rounded-md bg-skeleton" />
        )
      },
    },
  ]

  const mockData = Array.from({ length: 10 }, (_, index) => ({
    id: index,
  }))

  return (
    <DataTable
      data={mockData}
      columns={columns}
    />
  )
})

FunnelChecksTableSkeleton.displayName = 'FunnelChecksTableSkeleton'
